export default __webpack_public_path__ + "static/media/three.a1c1b38b.jpeg";